import {
  Module,
  VuexModule,
  Mutation,
  getModule,
} from "vuex-module-decorators";
import store from "@/store";
import { createDefaultHyDryMessagesSettings, HyDryMessagesSettings } from "@/data/models/HyDryMessagesConfig";

const name = "hyDryMessagesSettings";

@Module({ dynamic: true, namespaced: true, store, name: name })
export class HyDryMessagesSettingsVuexModule extends VuexModule {
  hyDryMessagesSettings: HyDryMessagesSettings = createDefaultHyDryMessagesSettings();

  @Mutation
  setHyDryMessagesSettings(hyDryMessagesSettings: HyDryMessagesSettings) {
    this.hyDryMessagesSettings = hyDryMessagesSettings;
  }

  @Mutation
  clear() {
    this.hyDryMessagesSettings = createDefaultHyDryMessagesSettings();
  }
}

export const HyDryMessagesSettingsModule = getModule(HyDryMessagesSettingsVuexModule, store);
